// extracted by mini-css-extract-plugin
export default {"no_scrollbar":"scrollbar_no_scrollbar__UMQkF"};